/** Arabic: English wording -> العربية. */
export default {
  'Add image': 'إضافة صورة',
  'Admit all': 'قبول الجميع',
  'Anyone with the link joins directly': 'يدخل مباشرة كل من لديه الرابط',
  'Back to home': 'العودة إلى الرئيسية',
  'Background options': 'خيارات الخلفية',
  'Calendar not connected': 'التقويم غير متصل',
  'Camera is off': 'الكاميرا متوقفة',
  'Camera is starting…': 'جارٍ تشغيل الكاميرا…',
  'Can’t reach the host': 'تعذّر الوصول إلى المضيف',
  'Can’t reach the meeting service. Check your connection and try again.': 'تعذّر الوصول إلى خدمة الاجتماعات. تحقق من اتصالك وأعد المحاولة.',
  'Change background': 'تغيير الخلفية',
  'Chat message': 'رسالة',
  'Choose from Calendar…': 'اختر من التقويم…',
  'Close panel': 'إغلاق اللوحة',
  'Closed room': 'غرفة مغلقة',
  'Connecting…': 'جارٍ الاتصال…',
  'Connection lost': 'انقطع الاتصال',
  'Copy joining link': 'نسخ رابط الانضمام',
  'Copy meeting code': 'نسخ رمز الاجتماع',
  'Copy meeting link': 'نسخ رابط الاجتماع',
  'Couldn’t reach Calendar': 'تعذّر الوصول إلى التقويم',
  'Create a meeting for later': 'إنشاء اجتماع لوقت لاحق',
  'Earlier today': 'في وقت سابق اليوم',
  'Enter a code or link': 'أدخل رمزًا أو رابطًا',
  'Everyone has left, so the meeting is over.': 'غادر الجميع، وانتهى الاجتماع.',
  'Exit full screen': 'الخروج من ملء الشاشة',
  'Exit picture-in-picture': 'الخروج من صورة داخل صورة',
  'Filters out background noise like typing, fans, and traffic': 'يحجب ضوضاء الخلفية مثل الكتابة والمراوح والمرور',
  'From your CRM': 'من نظام CRM الخاص بك',
  'Full screen': 'ملء الشاشة',
  'Guests wait until you let them in': 'ينتظر الضيوف حتى تسمح لهم بالدخول',
  'Hand raised': 'تم رفع اليد',
  'Here’s your meeting link': 'هذا رابط اجتماعك',
  'Host controls': 'أدوات المضيف',
  'In-call messages': 'رسائل الاجتماع',
  'Join now': 'انضم الآن',
  'Joining info': 'معلومات الانضمام',
  'Joining…': 'جارٍ الانضمام…',
  'Keyboard shortcuts': 'اختصارات لوحة المفاتيح',
  'Leave call': 'مغادرة الاجتماع',
  'Leave waiting room': 'مغادرة غرفة الانتظار',
  'Loading…': 'جارٍ التحميل…',
  'Loading your calendar…': 'جارٍ تحميل تقويمك…',
  'Loading your meetings': 'جارٍ تحميل اجتماعاتك',
  'Lock meeting': 'قفل الاجتماع',
  'Lower hand': 'خفض اليد',
  'Meeting PIN': 'رمز PIN للاجتماع',
  'Meeting code': 'رمز الاجتماع',
  'Meeting code copied': 'تم نسخ رمز الاجتماع',
  'Meeting code or link': 'رمز أو رابط الاجتماع',
  'Meeting details': 'تفاصيل الاجتماع',
  'Meeting link': 'رابط الاجتماع',
  'Meeting link copied': 'تم نسخ رابط الاجتماع',
  'Meeting link or code': 'رابط أو رمز الاجتماع',
  'Meeting passcode': 'كلمة مرور الاجتماع',
  'Messages are only visible to people in the call right now and are deleted when the call ends.': 'الرسائل مرئية فقط للحاضرين الآن وتُحذف عند انتهاء الاجتماع.',
  'Microphone on': 'الميكروفون يعمل',
  'More options': 'المزيد من الخيارات',
  'Mute everyone': 'كتم الجميع',
  'New meeting': 'اجتماع جديد',
  'New messages': 'رسائل جديدة',
  'Next up': 'التالي',
  'Next week': 'الأسبوع القادم',
  'No account needed to join': 'لا حاجة إلى حساب للانضمام',
  'No effect': 'بدون تأثير',
  'No meetings with a link': 'لا توجد اجتماعات برابط',
  'No messages yet': 'لا توجد رسائل بعد',
  'No one new can join': 'لا يمكن لأحد جديد الانضمام',
  'No passcode': 'بدون كلمة مرور',
  'Noise suppression': 'إلغاء الضوضاء',
  'Notify the host again': 'تنبيه المضيف مرة أخرى',
  'Open Calendar': 'فتح التقويم',
  'Open link': 'فتح الرابط',
  'Open room': 'غرفة مفتوحة',
  'Or paste a link': 'أو الصق رابطًا',
  'PIN code (optional)': 'رمز PIN (اختياري)',
  'PIN code for guests': 'رمز PIN للضيوف',
  'Paste a meeting link or code': 'الصق رابط أو رمز الاجتماع',
  'People': 'المشاركون',
  'People waiting to join': 'أشخاص بانتظار الانضمام',
  'Picture-in-picture': 'صورة داخل صورة',
  'Pin to screen': 'تثبيت على الشاشة',
  'Please enter your name.': 'يرجى إدخال اسمك.',
  'Present now': 'مشاركة الشاشة',
  'Previous week': 'الأسبوع السابق',
  'Raise hand': 'رفع اليد',
  'Ready to join?': 'جاهز للانضمام؟',
  'Ready to start?': 'جاهز للبدء؟',
  'Reconnecting…': 'جارٍ إعادة الاتصال…',
  'Replace image': 'استبدال الصورة',
  'Restart meeting': 'إعادة بدء الاجتماع',
  'Return to home screen': 'العودة إلى الشاشة الرئيسية',
  'Room type': 'نوع الغرفة',
  'Save nickname': 'حفظ الاسم المستعار',
  'Send a message to everyone': 'أرسل رسالة إلى الجميع',
  'Send a reaction': 'إرسال تفاعل',
  'Send message': 'إرسال',
  'Settings': 'الإعدادات',
  'Sign in through your CRM to start a meeting.': 'سجّل الدخول عبر CRM لبدء اجتماع.',
  'Sign in with trtCRM': 'تسجيل الدخول عبر trtCRM',
  'Sign out': 'تسجيل الخروج',
  'Slight blur': 'تمويه خفيف',
  'Start / join': 'ابدأ / انضم',
  'Start a new meeting': 'بدء اجتماع جديد',
  'Start an instant meeting': 'بدء اجتماع فوري',
  'Start meeting': 'بدء الاجتماع',
  'Start or join': 'ابدأ أو انضم',
  'Start this meeting': 'بدء هذا الاجتماع',
  'Starting soon': 'يبدأ قريبًا',
  'Starting…': 'جارٍ البدء…',
  'Stop presenting': 'إيقاف المشاركة',
  'Stop waiting': 'إيقاف الانتظار',
  'Switch to dark theme': 'التبديل إلى السمة الداكنة',
  'Switch to light theme': 'التبديل إلى السمة الفاتحة',
  'The meeting has ended': 'انتهى الاجتماع',
  'The meeting is starting': 'الاجتماع على وشك البدء',
  'The meeting is running': 'الاجتماع جارٍ',
  'Toggle camera': 'تبديل الكاميرا',
  'Toggle microphone': 'تبديل الميكروفون',
  'Try again': 'أعد المحاولة',
  'Turn off camera': 'إيقاف الكاميرا',
  'Turn off microphone': 'إيقاف الميكروفون',
  'Turn on': 'تشغيل',
  'Updating…': 'جارٍ التحديث…',
  'Upload an image': 'رفع صورة',
  'Waiting for the host': 'بانتظار المضيف',
  'Waiting for the host to let you in': 'بانتظار سماح المضيف بدخولك',
  'Waiting for the host…': 'بانتظار المضيف…',
  'You left the meeting': 'لقد غادرت الاجتماع',
  'Your image': 'صورتك',
  'Your meeting is ready. Share the link to invite others.': 'اجتماعك جاهز. شارك الرابط لدعوة الآخرين.',
  'Your name': 'اسمك',
  'Your presentation': 'عرضك',
  'You’re sharing your screen': 'أنت تشارك شاشتك',
  'Rejoin': 'إعادة الانضمام',
  'Notes': 'الملاحظات',
  'Start recording': 'بدء التسجيل',
  'Stop recording': 'إيقاف التسجيل',
  'Download notes': 'تنزيل الملاحظات',
  'Your notes are private to you and kept on this device until you close the tab.': 'ملاحظاتك خاصة بك وتبقى على هذا الجهاز حتى تغلق التبويب.',
  'Write your notes here…': 'اكتب ملاحظاتك هنا…',
  'Recording saved to your device': 'تم حفظ التسجيل على جهازك',
  'Recording is not available in this browser.': 'التسجيل غير متاح في هذا المتصفح.',
  'Language': 'اللغة',
  "Loading profile picture": "جارٍ تحميل صورة الملف الشخصي",
  "Meetings from your calendar show up here. Add a trtMeet meeting link to an event in your CRM, and it is one click away.": "تظهر هنا اجتماعات تقويمك. أضف رابط اجتماع trtMeet إلى حدث في نظام CRM وسيصبح متاحًا بنقرة واحدة.",
  "Your meetings will show here once the Calendar app answers.": "ستظهر اجتماعاتك هنا بمجرد استجابة تطبيق التقويم.",
  "Couldn’t update from Calendar": "تعذّر التحديث من التقويم",
  "Last known": "آخر حالة معروفة",
  "Calendar is not available right now": "التقويم غير متاح حاليًا",
  "Enter a meeting code or paste a meeting link.": "أدخل رمز اجتماع أو الصق رابط اجتماع.",
  "Start or rejoin from Calendar": "ابدأ أو انضم من التقويم",
  "One moment.": "لحظة من فضلك.",
  "Your CRM meetings appear here once you are signed in through the CRM. You can still paste a link below.": "تظهر اجتماعات CRM هنا بعد تسجيل الدخول عبر CRM. يمكنك دائمًا لصق رابط أدناه.",
  "The Calendar app didn’t answer. Check that it is installed, then try again — or paste a link below.": "لم يستجب تطبيق التقويم. تحقق من تثبيته ثم أعد المحاولة، أو الصق رابطًا أدناه.",
  "Camera is off. Effects apply when it’s back on": "الكاميرا متوقفة. ستُطبَّق التأثيرات عند تشغيلها",
  "Couldn’t read that image. Try a different file.": "تعذّرت قراءة هذه الصورة. جرّب ملفًا آخر.",
  "Toggle theme": "تبديل السمة",
  "Toggle light/dark theme": "تبديل السمة الفاتحة/الداكنة",
  "Start a call in seconds, or create a link to share for later. It all runs in your browser.": "ابدأ اجتماعًا في ثوانٍ أو أنشئ رابطًا لمشاركته لاحقًا. كل شيء يعمل في متصفحك.",
  "Hosts sign in with trtCRM. Joining a meeting needs no account: paste the link or code you were given.": "يسجّل المضيفون الدخول عبر trtCRM. الانضمام إلى اجتماع لا يتطلب حسابًا: الصق الرابط أو الرمز الذي وصلك.",
  "Nothing to install": "لا حاجة إلى تثبيت",
  "Links never expire": "الروابط لا تنتهي صلاحيتها",
  "No CRM is configured.": "لم يتم إعداد أي CRM.",
  "Could not set up a reusable link, so this meeting uses a one-time link.": "تعذّر إنشاء رابط قابل لإعادة الاستخدام، لذا يستخدم هذا الاجتماع رابطًا لمرة واحدة.",
  "Turn off microphone (⌘/Ctrl+D)": "إيقاف الميكروفون (⌘/Ctrl+D)",
  "Turn off camera (⌘/Ctrl+E)": "إيقاف الكاميرا (⌘/Ctrl+E)",
  "The host left the meeting. Finding a new host…": "غادر المضيف الاجتماع. جارٍ البحث عن مضيف جديد…",
  "The host muted your microphone": "قام المضيف بكتم الميكروفون الخاص بك",
  "Screen sharing failed.": "فشلت مشاركة الشاشة.",
  "Picture-in-picture isn’t available right now.": "خاصية صورة داخل صورة غير متاحة حاليًا.",
  "Copy failed. Select the link in Meeting details to copy it.": "فشل النسخ. حدّد الرابط في تفاصيل الاجتماع لنسخه.",
  "Copy failed. Select the text manually.": "فشل النسخ. حدّد النص يدويًا.",
  "Close panels and menus": "إغلاق اللوحات والقوائم",
  "Not available": "غير متاح",
  "Nickname saved": "تم حفظ الاسم المستعار",
  "Shown to everyone in your meeting and remembered for future meetings.": "يظهر للجميع في اجتماعك ويُحفظ للاجتماعات القادمة.",
  "Share this link with people you want in the meeting. It never changes, so anyone with it can join whenever this meeting is running, today or next week.": "شارك هذا الرابط مع من تريد دعوتهم. لا يتغير أبدًا، فيمكن لكل من يملكه الانضمام متى كان الاجتماع جاريًا، اليوم أو الأسبوع القادم.",
  "Share this link with people you want in the meeting. Anyone with the link can ask to join while the meeting is running.": "شارك هذا الرابط مع من تريد دعوتهم. يمكن لكل من يملكه طلب الانضمام أثناء الاجتماع.",
  "Passcode set": "تم تعيين كلمة المرور",
  "Passcode removed": "تمت إزالة كلمة المرور",
  "Join-request alerts are blocked in your browser settings.": "تنبيهات طلبات الانضمام محظورة في إعدادات متصفحك.",
  "Get an alert when someone asks to join, even from another tab.": "احصل على تنبيه عندما يطلب أحد الانضمام، حتى من تبويب آخر.",
  "Messages can only be seen by people in the call and are deleted when the call ends.": "الرسائل مرئية فقط للحاضرين وتُحذف عند انتهاء الاجتماع.",
  "This browser has no picture-in-picture.": "هذا المتصفح لا يدعم صورة داخل صورة.",
  "Back to the meeting tab": "العودة إلى تبويب الاجتماع",
  "Turn on a camera or present to float the meeting.": "شغّل كاميرا أو شارك الشاشة لعرض الاجتماع عائمًا.",
  "Open room: anyone with the link joins directly": "غرفة مفتوحة: يدخل مباشرة كل من لديه الرابط",
  "Try connecting to the meeting again": "أعد محاولة الاتصال بالاجتماع",
  "That passcode didn’t work. Check it and try again.": "لم تنجح كلمة المرور هذه. تحقق منها وأعد المحاولة.",
  "This meeting needs a passcode. Ask the host for it.": "يتطلب هذا الاجتماع كلمة مرور. اطلبها من المضيف.",
  "Could not reach the meeting service to start this meeting. It will be tried again in a moment.": "تعذّر الوصول إلى الخدمة لبدء هذا الاجتماع. ستتم المحاولة مجددًا بعد قليل.",
  "The meeting link couldn’t be updated just now. Guests may not find this meeting until it can be.": "تعذّر تحديث رابط الاجتماع الآن. قد لا يجد الضيوف الاجتماع حتى يتم تحديثه.",
  "The meeting link couldn’t be updated just now. New participants may not find this meeting until it can be.": "تعذّر تحديث رابط الاجتماع الآن. قد لا يجد المشاركون الجدد الاجتماع حتى يتم تحديثه.",
  "Host notified ✓": "تم تنبيه المضيف ✓",
  "This is a closed room. We’ve told the host you’re here — stay on this page and you’ll join as soon as they admit you.": "هذه غرفة مغلقة. تم إبلاغ المضيف بوجودك، ابقَ في هذه الصفحة وستنضم فور قبوله لك.",
  "We can’t reach the host right now. They may have lost their connection or left. We’ll keep trying and you’ll be let in as soon as they’re back — or leave and try the link again later.": "تعذّر الوصول إلى المضيف حاليًا. ربما انقطع اتصاله أو غادر. سنواصل المحاولة وستدخل فور عودته، أو غادر وجرّب الرابط لاحقًا.",
  "Someone is starting the meeting right now. Connecting you — this usually takes a few seconds.": "يقوم أحدهم ببدء الاجتماع الآن. جارٍ توصيلك، وعادةً يستغرق ذلك بضع ثوانٍ.",
  "Your network is blocking the connection. Try another network or a phone hotspot, or ask the host to check that guests can use relays.": "شبكتك تحجب الاتصال. جرّب شبكة أخرى أو نقطة اتصال من الهاتف، أو اطلب من المضيف التحقق من إتاحة المرحّلات للضيوف.",
  "Still trying to get you in. Ask the host to check their connection, or to share the link again.": "لا نزال نحاول إدخالك. اطلب من المضيف التحقق من اتصاله أو مشاركة الرابط مجددًا.",
  "Can’t reach the meeting service — retrying…": "تعذّر الوصول إلى خدمة الاجتماعات — جارٍ إعادة المحاولة…",
  "The host is here, but their link is being refreshed. Connecting you — this usually takes a few seconds.": "المضيف موجود لكن رابطه قيد التحديث. جارٍ توصيلك، وعادةً يستغرق ذلك بضع ثوانٍ.",
  "We can’t reach the meeting service right now. Check your connection — you’ll join automatically once it’s back.": "تعذّر الوصول إلى خدمة الاجتماعات حاليًا. تحقق من اتصالك، وستنضم تلقائيًا فور عودتها.",
  "The meeting hasn’t started yet. You’ll join automatically when it starts.": "لم يبدأ الاجتماع بعد. ستنضم تلقائيًا عند بدئه.",
  "The meeting hasn’t started yet. You’ll join automatically when it starts, or you can start it now.": "لم يبدأ الاجتماع بعد. ستنضم تلقائيًا عند بدئه، أو يمكنك بدءه الآن.",
  "You’ll get a reusable link that works every time this meeting runs.": "ستحصل على رابط قابل لإعادة الاستخدام يعمل في كل مرة يُعقد فيها هذا الاجتماع.",
  "Sign in to start a meeting — opening the sign-in page…": "سجّل الدخول لبدء اجتماع — جارٍ فتح صفحة تسجيل الدخول…",
  "You and the host are on different versions of trtMeet. Both of you should hard-refresh the page (⌘/Ctrl+Shift+R) and try again with a new meeting link.": "أنت والمضيف تستخدمان إصدارين مختلفين من trtMeet. أعيدا تحميل الصفحة بالكامل (⌘/Ctrl+Shift+R) وجرّبا برابط اجتماع جديد.",
  "Connected, but the meeting never answered. Make sure the host still has the meeting open. If this keeps happening, both of you should hard-refresh the page (⌘/Ctrl+Shift+R) to get the latest version.": "تم الاتصال لكن الاجتماع لم يستجب. تأكد أن المضيف لا يزال يفتح الاجتماع. إن تكرر ذلك فأعيدا تحميل الصفحة بالكامل (⌘/Ctrl+Shift+R) للحصول على آخر إصدار.",
  "Could not reach the meeting. Check the code and try again.": "تعذّر الوصول إلى الاجتماع. تحقق من الرمز وأعد المحاولة.",
  "The meeting is unavailable. The host may have left.": "الاجتماع غير متاح. ربما غادر المضيف.",
  "Your preview is hidden to prevent mirroring.": "تم إخفاء معاينتك لتجنب تأثير المرآة.",
  "The host removed you from the meeting.": "أزالك المضيف من الاجتماع.",
  "Your meeting link is working again.": "رابط اجتماعك يعمل مجددًا.",
  "Someone else started a meeting on this link at the same time. New participants will join theirs; this meeting carries on for everyone in it.": "بدأ شخص آخر اجتماعًا على هذا الرابط في الوقت نفسه. سينضم المشاركون الجدد إلى اجتماعه، ويستمر هذا الاجتماع لمن فيه.",
  "The meeting continued under a new host while you were disconnected. New participants will join them.": "استمر الاجتماع مع مضيف جديد أثناء انقطاعك. سينضم المشاركون الجدد إليه.",
  "The meeting continued under a new host while you were disconnected — you’ve rejoined it.": "استمر الاجتماع مع مضيف جديد أثناء انقطاعك — وقد عدت إليه.",
  "Someone else started this meeting at the same time — you’ve joined them.": "بدأ شخص آخر هذا الاجتماع في الوقت نفسه — وقد انضممت إليه.",
  "Your trtCRM session has ended. You can finish this call; you will be signed out when it ends.": "انتهت جلسة trtCRM الخاصة بك. يمكنك إنهاء هذا الاجتماع وسيتم تسجيل خروجك عند انتهائه.",
  "Captions": "الترجمة النصية",
  "Turn on captions": "تشغيل الترجمة النصية",
  "Turn off captions": "إيقاف الترجمة النصية",
  "Captions are not available in this browser.": "الترجمة النصية غير متاحة في هذا المتصفح.",
  "Assistant": "المساعد",
  "Meeting assistant": "مساعد الاجتماع",
  "Summarize the meeting": "تلخيص الاجتماع",
  "Ask about the meeting…": "اسأل عن الاجتماع…",
  "Ask": "اسأل",
  "Thinking…": "جارٍ التفكير…",
  "Turn on captions first: the assistant works from what was said.": "شغّل الترجمة النصية أولًا: يعتمد المساعد على ما قيل.",
  "The assistant could not answer right now. Try again in a moment.": "تعذّر على المساعد الرد الآن. أعد المحاولة بعد قليل.",
  "The assistant reads the captions of this meeting and sends them to an AI service to answer. Only team members can use it.": "يقرأ المساعد الترجمة النصية لهذا الاجتماع ويرسلها إلى خدمة ذكاء اصطناعي للإجابة. مخصص لأعضاء الفريق فقط.",
  "Download transcript": "تنزيل النص الكامل",
  "Book a meeting": "احجز موعدًا",
  "Pick a day and an hour that suit you. Meetings last one hour.": "اختر اليوم والساعة المناسبين لك. مدة الموعد ساعة واحدة.",
  "Previous month": "الشهر السابق",
  "Next month": "الشهر التالي",
  "Bookings are not available right now. Try again in a moment.": "الحجز غير متاح حاليًا. أعد المحاولة بعد قليل.",
  "No free hours this month.": "لا توجد ساعات متاحة هذا الشهر.",
  "Email": "البريد الإلكتروني",
  "Phone (optional)": "الهاتف (اختياري)",
  "What would you like to talk about? (optional)": "ما الذي تود مناقشته؟ (اختياري)",
  "Confirm booking": "تأكيد الحجز",
  "Sending…": "جارٍ الإرسال…",
  "Back": "رجوع",
  "Please enter a valid email address.": "يرجى إدخال بريد إلكتروني صحيح.",
  "Please enter a valid phone number.": "يرجى إدخال رقم هاتف صحيح.",
  "Sorry, that hour was just taken. Please pick another.": "عذرًا، تم حجز هذه الساعة للتو. يرجى اختيار ساعة أخرى.",
  "You already have several upcoming bookings.": "لديك بالفعل عدة مواعيد قادمة.",
  "Too many attempts. Please try again later.": "محاولات كثيرة. يرجى المحاولة لاحقًا.",
  "Could not book right now. Please try again.": "تعذّر الحجز الآن. يرجى المحاولة مرة أخرى.",
  "Your meeting is booked": "تم حجز موعدك",
  "Keep this link. At the time, open it to join:": "احتفظ بهذا الرابط. في الموعد افتحه للانضمام:",
  "Add to calendar": "إضافة إلى التقويم",
  "Book another": "احجز موعدًا آخر",
  "Appointments": "المواعيد",
  "Step 1 of 3": "الخطوة 1 من 3",
  "Step 2 of 3": "الخطوة 2 من 3",
  "Step 3 of 3": "الخطوة 3 من 3",
  "Date and time": "التاريخ والوقت",
  "Your details": "بياناتك",
  "Your needs": "احتياجاتك",
  "Phone": "الهاتف",
  "Country": "الدولة",
  "Services needed": "الخدمات المطلوبة",
  "Website (optional)": "الموقع الإلكتروني (اختياري)",
  "Next": "التالي",
  "Please choose your country.": "يرجى اختيار دولتك.",
  "Choose at least one service.": "اختر خدمة واحدة على الأقل.",
  "Please enter a valid website address.": "يرجى إدخال عنوان موقع صحيح.",
  "Accept": "قبول",
  "Edit": "تعديل",
  "Delete": "حذف",
  "Cancel": "إلغاء",
  "Save": "حفظ",
  "Pending": "قيد الانتظار",
  "Not in CRM": "غير موجود في CRM",
  "Send to CRM": "إرسال إلى CRM",
  "Send all to CRM": "إرسال الكل إلى CRM",
  "Delete this appointment?": "حذف هذا الموعد؟",
  "The hour becomes free again for other visitors.": "تصبح هذه الساعة متاحة مجددًا للزوار الآخرين.",
  "Edit appointment": "تعديل الموعد",
  "Name": "الاسم",
  "Note": "ملاحظة",
  "Your request was sent": "تم إرسال طلبك",
  "We will confirm this hour shortly. Keep this link; at the time, open it to join:": "سنؤكد هذه الساعة قريبًا. احتفظ بهذا الرابط وافتحه في الموعد للانضمام:",
  "That hour is taken.": "هذه الساعة محجوزة.",
  "Could not save.": "تعذّر الحفظ.",
  "Refuse": "رفض",
  "Refuse this appointment?": "رفض هذا الموعد؟",
  "The hour becomes free again and the CRM tells the visitor.": "تصبح الساعة متاحة مجددًا ويُبلغ CRM الزائر.",
  "Saved here, but the CRM did not accept the change.": "تم الحفظ هنا لكن CRM لم يقبل التغيير.",
  "Done. The CRM calendar is updated.": "تم. تم تحديث تقويم CRM.",
  "Done.": "تم.",
  "Open the CRM calendar": "فتح تقويم CRM",
  "Sign in": "تسجيل الدخول",
  "Prepare the recap for the CRM": "تحضير الملخص لـ CRM",
  "Create this task": "إنشاء هذه المهمة",
  "Task": "مهمة",
  "Recap": "الملخص",
  "Decisions": "القرارات",
  "Open questions": "أسئلة مفتوحة",
  "Action items": "الإجراءات المطلوبة",
  "Save to the CRM": "حفظ في CRM",
  "Saving…": "جارٍ الحفظ…",
  "Saved on the CRM event": "تم الحفظ على حدث CRM",
  "task(s) created": "مهمة تم إنشاؤها",
  "already there": "موجودة مسبقًا",
  "No event of the CRM calendar uses this meeting link: create the event in the CRM calendar with this link, then save again.": "لا يوجد حدث في تقويم CRM يستخدم رابط هذا الاجتماع: أنشئ الحدث في تقويم CRM بهذا الرابط ثم احفظ مجددًا.",
  "You cannot write on that CRM event.": "لا يمكنك الكتابة على حدث CRM هذا.",
  "Could not save to the CRM right now. Try again in a moment.": "تعذّر الحفظ في CRM الآن. حاول مجددًا بعد قليل.",
};
